/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostBookingPlanSuccessResponseData
 */
export interface PostBookingPlanSuccessResponseData {
    /**
     * プラン変更受付メールの送信に成功したか
     * @type {boolean}
     * @memberof PostBookingPlanSuccessResponseData
     */
    isSentSuccess: boolean;
    /**
     * プラン変更受付メールを送信したメールアドレス
     * @type {string}
     * @memberof PostBookingPlanSuccessResponseData
     */
    sentMailAddress: string;
}

export function PostBookingPlanSuccessResponseDataFromJSON(json: any): PostBookingPlanSuccessResponseData {
    return PostBookingPlanSuccessResponseDataFromJSONTyped(json, false);
}

export function PostBookingPlanSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostBookingPlanSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSentSuccess': json['is_sent_success'],
        'sentMailAddress': json['sent_mail_address'],
    };
}

export function PostBookingPlanSuccessResponseDataToJSON(value?: PostBookingPlanSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_sent_success': value.isSentSuccess,
        'sent_mail_address': value.sentMailAddress,
    };
}

